export default __webpack_public_path__ + "static/media/restore.c99a88b3.svg";